<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main">
  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-3">Notifications</h4>
  </div>
  <div class="row pat-20 pab-20">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body el-layout-1">
          <div *ngIf="(alertList ==null || alertList.length==0)">
            <div class="row">
              <div class="no-data-home">
                <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                <h5>No Data Available</h5>
              </div>
            </div>
          </div>
          <div class="row pageloadcontainer">
            <div class="col-lg-12 bg-white border-el mat-20" id="notification-main-page">
              <a class="pointer alert-box border-bottom d-block mb-3" (click)="loadValues(alertObj)"
                 *ngFor="let alertObj of alertList; let alertIndex = index;">
                <div class="alert-img pointer position-absolute position-left-15" >
                  
                </div>
                <div class="alert-name pointer position-relative" (click)="openViewMeetingAndAttendance(template1,alertObj.genInfoUno,alertObj.type)">
                  <!--<div class="card-controls position-absolute position-top-0 position-right-15"><a class="card-refresh text-black text-danger">
                    <i class="la la-info-circle fa-lg mx-1"></i></a>
                  </div>-->
                  <p class="mb-2">{{alertObj.description}}<br /> <small class="text-secondary">{{alertObj.createdDate |timeAgo}} </small>|  <span>{{alertObj.type}}</span> </p>

                </div>
              </a>

            </div>
          </div>

        </div>

        <div class="col-lg-12 mb-3 text-center text-info pointer" *ngIf="!disableMore">
          <button class="pointer btn btn-outline-secondary" (click)="loadAlerts()">
            <i class="fa fa-refresh mar5px"></i> Show  More...
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>


<ng-template #template1>
  <div class="modal-header border-0 pb-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="modalMeeting.hide();">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div>
  <div *ngIf="pagetype=='MEETING'">
    <app-view-meeting pagetype="MEETING" [mid]="mid"></app-view-meeting>
  </div>
  <div *ngIf="pagetype=='ATTENDANCE'">
    <app-view-attendence pagetype="ATTENDANCE" [mid]="mid"></app-view-attendence>
  </div>


</ng-template>
